import { a6 as attr, a7 as stringify, R as slot, a0 as bind_props, P as pop, aa as sanitize_props, N as push } from "./index.js";
function Link($$payload, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  push();
  let to = $$props["to"];
  $$payload.out += `<a${attr("class", `group text-md flex items-center font-display font-medium !text-inherit hover:opacity-70 no-underline transition-all cursor-pointer ${stringify($$sanitized_props.class)} gap-2`)}${attr("href", to)}><!---->`;
  slot($$payload, $$props, "default", {});
  $$payload.out += `<!----> <i class="material-symbols-outlined !text-sm !font-bold pointer-events-none -translate-x-1 group-hover:translate-x-0 relative flex items-center justify-center w-4 h-[24px] !leading-[24px] transition-transform"><span class="opacity-100 group-hover:opacity-0 absolute">keyboard_arrow_right</span> <span class="opacity-0 group-hover:opacity-100 absolute">arrow_right_alt</span></i></a>`;
  bind_props($$props, { to });
  pop();
}
export {
  Link as L
};
